/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 medal5.glb --transform 
Files: medal5.glb [1.83MB] > H:\objects\medal5-transformed.glb [198.6KB] (89%)
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Medal5(props) {
  const { nodes, materials } = useGLTF('3dmodels/medal5-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={[1, 0.038, 1]}>
        <mesh geometry={nodes.Cylinder_1.geometry} material={materials.Awers} />
        <mesh geometry={nodes.Cylinder_2.geometry} material={materials['Awers.001']} />
        <mesh geometry={nodes.Cylinder_3.geometry} material={materials.Bok} />
      </group>
    </group>
  )
}

useGLTF.preload('3dmodels/medal5-transformed.glb')
